import { gql } from '@apollo/client';

export const CONTRACTOR_CREATE = gql`
  mutation ContractorCreate($input: ContractorCreateInput!) {
    contractorCreate(input: $input) {
      id
      userId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
    }
  }
`;

export const CONTRACTOR_UPDATE = gql`
  mutation ContractorUpdate($id: ID!, $input: ContractorUpdateInput!) {
    contractorUpdate(id: $id, input: $input) {
      id
      userId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
    }
  }
`;

export const CONTRACTOR_DELETE = gql`
  mutation ContractorDelete($id: ID!) {
    contractorDelete(id: $id)
  }
`;
